import { FakeData } from "components/widget"
import Table from "components/widget/CTable/Table"


export const OverViewAgents = () => {

    const col = [
        {
            title: "Agent ",
            render: (i: any) => (
                <>
                    <div className={` flex items-center `}>
                        <div className="w-[35px] h-[35px] rounded-full bg-hoory-175 flex items-center justify-center text-hoory-200">R</div>
                        <div className="flex flex-col items-start ml-2">
                            <span className="text-sm">ryaz</span>
                            <span className="text-xs">farsifilm3@gmail.com</span>
                        </div>
                    </div>
                </>
            )
        },
        {
            title: "Open ",
            render: (i: any) => (<>{i?.package}</>)
        },
        {
            title: "Unattended ",
            render: (i: any) => (<>{i?.price}</>)
        },
    ]


    return (
        <div className="w-full  bg-hoory-100 rounded-lg mt-[15px] py-[10px] md:px-[20px] px-[10px]">
            <div className="w-full flex items-center ">
                <h3>Conversations by agents</h3>
                <div className="w-[50px] h-[18px] text-center rounded-md ml-2 flex items-center justify-center bg-[#e8fbef] text-[#5cd463] text-xs">
                    <span className="flex w-[5px] h-[5px] bg-[#5cd463] rounded-full mr-1"></span>
                    <span>Live</span>
                </div>
            </div>
            <div className="w-full   mt-5">
                <Table columns={col} data={FakeData} />
            </div>
        </div>
    )
}